"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhalconOne = void 0;
const env_1 = require("../../conf/env");
const base_api_1 = require("./base-api");
/**
 * @description api services for PhalconOne endpoints
 *
 * @export
 * @class PhalconOne
 * @extends {BaseApi<T>}
 * @template T
 */
class PhalconOne extends base_api_1.BaseApi {
    /**
     *Creates an instance of PhalconOne.
     * @param {*} authorizationToken
     * @param {*} domainPermissionToken
     * @memberof PhalconOne
     */
    constructor(authorizationToken, domainPermissionToken) {
        const axiosConfig = {
            baseURL: env_1.PHALCON_ONE_API,
            headers: {
                Authorization: `Bearer ${authorizationToken}`,
                "X-Gloow-Domain-Data": domainPermissionToken
            },
            timeout: 10000
        };
        super(axiosConfig);
        this.authToken = authorizationToken;
        this.domainToken = domainPermissionToken;
    }
    /**
     * @description performs a post with a generic query in Query Basic Language and returns a
     *
     * @template R
     * @param {string} urlSuffix: endpoint name on PhalconOne.
     * @param {{ [key: string]: any }} query : Query Language Basics, @see https://sailsjs.com/documentation/concepts/models-and-orm/query-language
     * @returns {Promise<R[]>}, where R is of the same type as the initiated PhalconOne Service, for example @interface iNode .
     * @memberof Phalconone
     */
    postSearchQuery(urlSuffix, query) {
        return this.post(urlSuffix, query);
    }
    /**
     * @description basic get with optional url parameters.
     *
     * @template R
     * @param {string} urlSuffix
     * @param {{ [key: string]: any }} [httpParams] most likly be a basic key value pair object, i.e. { "name" : "foo"} . For advanced queries, use @method postSearchQuery .
     * @returns {Promise<R[]>}
     * @memberof Phalconone
     */
    getSearchQuery(urlSuffix, httpParams) {
        return this.getAll(urlSuffix, httpParams);
    }
    uploadFile(urlSuffix, body, onUploadProgress) {
        console.log("uploading data");
        console.log(body);
        return this.post(urlSuffix, body, {
            onUploadProgress,
            headers: {
                Authorization: `Bearer ${this.authToken}`,
                "X-Gloow-Domain-Data": this.domainToken,
                'Content-Type': 'multipart/form-data',
            }
        });
    }
}
exports.PhalconOne = PhalconOne;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGhhbGNvbm9uZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wcml2YXRlL2FwaS1zZXJ2aWNlcy9waGFsY29ub25lLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLHdDQUFpRDtBQUVqRCx5Q0FBcUM7QUFFckM7Ozs7Ozs7R0FPRztBQUNILE1BQWEsVUFBYyxTQUFRLGtCQUFVO0lBTzNDOzs7OztPQUtHO0lBQ0gsWUFBWSxrQkFBa0IsRUFBRSxxQkFBcUI7UUFFbkQsTUFBTSxXQUFXLEdBQXVCO1lBQ3RDLE9BQU8sRUFBRSxxQkFBZTtZQUN4QixPQUFPLEVBQUU7Z0JBQ1AsYUFBYSxFQUFFLFVBQVUsa0JBQWtCLEVBQUU7Z0JBQzdDLHFCQUFxQixFQUFFLHFCQUFxQjthQUM3QztZQUNELE9BQU8sRUFBRSxLQUFLO1NBQ2YsQ0FBQztRQUVGLEtBQUssQ0FBQyxXQUFXLENBQUMsQ0FBQztRQUVuQixJQUFJLENBQUMsU0FBUyxHQUFHLGtCQUFrQixDQUFDO1FBQ3BDLElBQUksQ0FBQyxXQUFXLEdBQUcscUJBQXFCLENBQUM7SUFDM0MsQ0FBQztJQUVEOzs7Ozs7OztPQVFHO0lBQ0ksZUFBZSxDQUFRLFNBQWlCLEVBQUUsS0FBYTtRQUM1RCxPQUFPLElBQUksQ0FBQyxJQUFJLENBQU0sU0FBUyxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQzFDLENBQUM7SUFFRDs7Ozs7Ozs7T0FRRztJQUNJLGNBQWMsQ0FBUSxTQUFpQixFQUFFLFVBQW1CO1FBQ2pFLE9BQU8sSUFBSSxDQUFDLE1BQU0sQ0FBSSxTQUFTLEVBQUUsVUFBVSxDQUFDLENBQUM7SUFDL0MsQ0FBQztJQUVNLFVBQVUsQ0FDZixTQUFpQixFQUNqQixJQUFZLEVBQ1osZ0JBQXdEO1FBR3hELE9BQU8sQ0FBQyxHQUFHLENBQUUsZ0JBQWdCLENBQUUsQ0FBQztRQUNoQyxPQUFPLENBQUMsR0FBRyxDQUFFLElBQUksQ0FBRSxDQUFDO1FBRXBCLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBSSxTQUFTLEVBQUUsSUFBSSxFQUFFO1lBQ25DLGdCQUFnQjtZQUNoQixPQUFPLEVBQUU7Z0JBQ1AsYUFBYSxFQUFFLFVBQVUsSUFBSSxDQUFDLFNBQVMsRUFBRTtnQkFDekMscUJBQXFCLEVBQUUsSUFBSSxDQUFDLFdBQVc7Z0JBQ3ZDLGNBQWMsRUFBRSxxQkFBcUI7YUFDdEM7U0FBQyxDQUFDLENBQUM7SUFDUixDQUFDO0NBQ0Y7QUF6RUQsZ0NBeUVDIn0=